import { doc, getDoc } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { db } from '@/config/firebase';
import type { PreCadastroAdmissao } from '../models/preCadastroAdmissao.types';

/**
 * Só leitura — toda escrita de si_pre_cadastros_admissao acontece via Cloud Functions
 * (webhook do Forms + vínculo automático em onSolicitacaoWrite), nunca pelo client (ver
 * firestore.rules — `allow write: if false`). O vínculo manual também passa por function.
 */
export interface PreCadastroPendente {
  id: string;
  nome: string | null;
  emailPessoal: string | null;
  origem: 'sharepoint' | 'recrutamento';
  criadoEm: string | null;
}

class PreCadastroAdmissaoServiceClass {
  async getById(id: string): Promise<PreCadastroAdmissao | null> {
    const snap = await getDoc(doc(db, 'si_pre_cadastros_admissao', id));
    if (!snap.exists()) return null;
    return { id: snap.id, ...snap.data() } as PreCadastroAdmissao;
  }

  /** Pré-cadastros ainda sem vínculo (só nome/e-mail/origem/data) — pro vínculo manual. */
  async listarPendentes(): Promise<PreCadastroPendente[]> {
    const fn = httpsCallable<void, { pendentes: PreCadastroPendente[] }>(getFunctions(), 'listarPreCadastrosPendentesSi');
    return (await fn()).data.pendentes;
  }

  async vincularManual(solicitacaoId: string, preCadastroId: string): Promise<{ aplicadoAoColaborador: boolean }> {
    const fn = httpsCallable<{ solicitacaoId: string; preCadastroId: string }, { aplicadoAoColaborador: boolean }>(
      getFunctions(),
      'vincularPreCadastroManualSi'
    );
    return (await fn({ solicitacaoId, preCadastroId })).data;
  }
}

export const preCadastroAdmissaoService = new PreCadastroAdmissaoServiceClass();
